import dayjs from 'dayjs'
import relativeTime from 'dayjs/plugin/relativeTime'

dayjs.extend(relativeTime)

const DateTimeFormat = (dateString) => {
  const date = dayjs(dateString)
  const now = dayjs()
  const time = date.format('h:mm A')

  let formattedDate

  if (date.isSame(now, 'day')) {
    formattedDate = 'Today'
  } else if (date.isSame(now.clone().subtract(1, 'day'), 'day')) {
    formattedDate = 'Yesterday'
  } else if (now.diff(date, 'day') < 7) {
    formattedDate = date.fromNow()
  } else {
    formattedDate = date.format('DD MMM YYYY')
  }

  return {
    date: formattedDate,
    time: time
  }
}

export default DateTimeFormat
